import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { PlatformModeService } from '../services/platform-mode.service';

@Injectable({
  providedIn: 'root'
})
export class AccountEntryGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly platformModeService: PlatformModeService
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.platformModeService.isCompactViewport()) {
      return true;
    }

    return this.router.createUrlTree(['/account/profile']);
  }
}
